import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../../redux/actions/modal';
import SelectImageForm from './form';
import text from '../../../text';

export const IMAGE_CROPPER_MODAL = 'IMAGE_CROPPER_MODAL';

type ImageCropperModalProps = {
  show: boolean;
};

const ImageCropperModal: React.FC<ImageCropperModalProps> = ({ show }) => {
  const dispatch = useDispatch();

  const onHide = () => dispatch(hideModal(IMAGE_CROPPER_MODAL));

  const onSubmit = () => {
    onHide();
  };

  return (
    <Modal centered show={show} onHide={onHide} backdrop='static'>
      {/* @ts-expect-error - Modal.Header types since it's not TS */}
      <Modal.Header closeButton>
        <h3 className='secondary'>{text('changeCompanyLogo')}</h3>
      </Modal.Header>
      <SelectImageForm onSubmit={onSubmit} onCancel={onHide} />
    </Modal>
  );
};

export default ImageCropperModal;
